<template>
    <a-layout class="dynamic-form">
        <a-layout-sider class="left-sider">
            <WidgetPanel :modelFunction="modelFunction" />
        </a-layout-sider>
        <a-layout style="padding: 2px">
            <a-layout-header>
                <ToolBar :formJsonObj="designer.formJsonObj" :saveFunction="saveFunction" @clear="clearList"
                    @setJson="editOk" />
            </a-layout-header>
            <a-layout-content style="margin-top:2px;background: #fff" class="scrollBar">
                <FormWidget :formJsonObj="designer.formJsonObj" :formDataModel="designer.formDataModel" ref="designref" />
            </a-layout-content>
        </a-layout>
        <a-layout-sider class="right-sider">
            <SettingPanel @editName="editName" />
        </a-layout-sider>
    </a-layout>
</template>

<script>
export default {
	name: "FormDesign",
};
</script>
<script setup>
import { ref, reactive, toRefs, provide } from 'vue';
import WidgetPanel from "./widget-panel/index.vue";
import FormWidget from "./form-widget/index.vue";
import SettingPanel from "./setting-panel/index.vue";
import ToolBar from "./toolbar-panel/index.vue";

const designref = ref(null)
const designer = reactive({
    formDataModel: {},
    selectWidget: {},
    oldName: '',
    formJsonObj: {
        widgetList: [],
        formConfig: {
            labelWidth: 80,
            labelAlign: 'left',
            onFormMounted: '',
        },
    },
})

const props = defineProps({
    saveFunction: Object,
    modelFunction: Object,
})
const { saveFunction, modelFunction } = toRefs(props)

const getSelectWidget = () => {
    return designer.selectWidget
}
const getOldName = () => {
    return designer.oldName
}
const getFormConfig = () => {
    return designer.formJsonObj.formConfig
}
const getWidgetList = () => {
    return designer.formJsonObj.widgetList
}
const updateSelectWidget = (val) => {
    designer.selectWidget = val
    designer.oldName = val ? val.name : null
}
const updateFormConfig = (val) => {
    designer.formJsonObj.formConfig = val
}
const updateWidgetList = (val) => {
    designer.formJsonObj.widgetList = val
}
provide("designer", {
    getSelectWidget,
    getOldName,
    getFormConfig,
    getWidgetList,
    updateSelectWidget,
    updateFormConfig,
    updateWidgetList,
});

const editName = (newName) => {
    if (!newName || designref.value.getInstance(newName)) {
        designer.selectedWidget.name = designer.oldName
    } else {
        designref.value.updateInstance(designer.oldName, newName)
        designer.oldName = newName
    }
}

const clearList = () => {
    designer.formJsonObj.widgetList = []
    designref.value.destoryInstanceList()
    designer.formDataModel = {}
    updateSelectWidget(null)
}

const editOk = (val) => {
    designer.formJsonObj = JSON.parse(val)
}
</script>

<style>
.dynamic-form {
    height: 100%;
}

.ant-layout-header {
    background-color: #fff !important;
    height: 40px !important;
    padding: 0 15px !important;
}

/* 修改侧边栏宽度样式 */
/* .ant-layout-sider-dark  */
.left-sider {
    background: #fff !important;
    flex: 0 0 270px !important;
    max-width: 270px !important;
    min-width: 270px !important;
    width: 270px !important;
}

.right-sider {
    background: #fff !important;
    flex: 0 0 330px !important;
    max-width: 330px !important;
    min-width: 330px !important;
    width: 330px !important;
}

.ant-form-horizontal .ant-form-item-control {
    text-align: left;
}

.ant-input-number,
.ant-picker {
    width: 100% !important;
}

.scrollBar {
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-color: rgba(144, 147, 153, 0.3) transparent;
    /* 滑块颜色  滚动条背景颜色 */
    scrollbar-width: thin;
    /* 滚动条宽度有三种：thin、auto、none */
}

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

/* 滚动条的轨道的两端按钮，允许通过点击微调小方块的位置。 */
::-webkit-scrollbar-button {
    display: none;
}

/* 滚动条的轨道（里面装有Thumb） */
::-webkit-scrollbar-track {
    background: transparent;
}

/* 滚动条的轨道（里面装有Thumb） */
::-webkit-scrollbar-track-piece {
    background-color: transparent;
}

/* 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条） */
::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3);
    cursor: pointer;
    border-radius: 4px;
}

/* 边角，即两个滚动条的交汇处 */
::-webkit-scrollbar-corner {
    display: none;
}

/* 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件 */
::-webkit-resizer {
    display: none;
}

.form-widget-list .ghost {
    content: '';
    font-size: 0;
    height: 3px;
    box-sizing: border-box;
    background: blue;
    border: 2px solid blue;
    outline-width: 0;
    padding: 0;
    overflow: hidden;
}
</style>